export interface CurrentUser {
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  userRoles: UserTypes[];
}

export interface Session {
  user?: CurrentUser;
}

export enum UserTypes {
  /** Read/Write on all users */
  Admin = 'ADMIN',
  AccountManager = 'KEY_ACCOUNT_MANAGER',
  WasteDirector = 'WASTE_DIRECTOR',
  InternalSiteOperator = 'INTERNAL_SITE_OPERATOR',
  ExternalSiteOperator = 'EXTERNAL_SITE_OPERATOR',
  HaulingCompanyOwner = 'HAULING_COMPANY_OWNER',
  /** TODO: not currently used */
  Driver = 'DRIVER',
}
